import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../utils/api';

const CATEGORIES = [
  { id: 'wax',         label: 'Mode Wax',    icon: '🌺', desc: 'Tissus aux motifs colorés' },
  { id: 'bazin',       label: 'Bazin',        icon: '✨', desc: 'Élégance brodée' },
  { id: 'boubou',      label: 'Boubou',       icon: '👘', desc: 'Tenues de cérémonie' },
  { id: 'moderne',     label: 'Moderne',      icon: '🎽', desc: 'Prêt-à-porter tendance' },
  { id: 'accessoires', label: 'Accessoires',  icon: '👜', desc: 'Sacs, bijoux, chaussures' },
  { id: 'enfants',     label: 'Enfants',      icon: '🧒', desc: 'Mode pour les petits' },
];

export default function Home() {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/products?limit=4&sort=created_at')
      .then(r => setFeaturedProducts(r.data.products || []))
      .catch(() => {});
  }, []);

  return (
    <div style={{ background: 'var(--creme)', minHeight: '100vh' }}>

      {/* ── Hero ── */}
      <section style={{
        background: 'linear-gradient(135deg, var(--prune-dark) 0%, var(--prune) 50%, var(--prune-light) 100%)',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '100px 24px 60px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Ornements */}
        <div style={{ position: 'absolute', top: '10%', right: '5%', width: 300, height: 300, borderRadius: '50%', background: 'rgba(201,168,76,.08)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '10%', left: '5%', width: 200, height: 200, borderRadius: '50%', background: 'rgba(201,168,76,.06)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(201,168,76,.06) 0%, transparent 70%)', pointerEvents: 'none' }} />

        {/* Badge */}
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(201,168,76,.15)', border: '1px solid rgba(201,168,76,.3)', borderRadius: 'var(--radius-full)', padding: '6px 18px', marginBottom: 32 }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--or)', display: 'inline-block' }} />
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.2em', color: 'var(--or)' }}>Collection 2025 — Côte d'Ivoire</span>
        </div>

        <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 300, fontSize: 'clamp(44px, 7vw, 88px)', color: 'var(--creme)', lineHeight: 1.05, marginBottom: 20 }}>
          Mode Africaine<br />
          <span style={{ fontStyle: 'italic', color: 'var(--or-light)' }}>Haut de Gamme</span>
        </h1>

        <p style={{ fontSize: 17, color: 'rgba(253,246,236,.7)', maxWidth: 520, lineHeight: 1.8, marginBottom: 48 }}>
          Wax · Bazin · Boubou · Prêt-à-porter<br />
          Livraison à Abidjan et partout en Côte d'Ivoire
        </p>

        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 64 }}>
          <Link to="/boutique" style={{
            padding: '16px 40px', background: 'var(--or)', color: 'var(--prune-dark)',
            borderRadius: 'var(--radius-md)', fontSize: 15, fontWeight: 700,
            textDecoration: 'none', fontFamily: 'var(--font-body)',
            boxShadow: 'var(--shadow-or)', transition: 'all .2s',
          }}>
            Découvrir la collection →
          </Link>
          <Link to="/inscription" style={{
            padding: '16px 40px', background: 'transparent', color: 'var(--creme)',
            borderRadius: 'var(--radius-md)', fontSize: 15, fontWeight: 500,
            textDecoration: 'none', border: '1px solid rgba(253,246,236,.25)',
            fontFamily: 'var(--font-body)', transition: 'all .2s',
          }}>
            Créer un compte
          </Link>
        </div>

        {/* Badges paiement */}
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
          {[
            { label: 'MTN Mobile Money', emoji: '📱', bg: 'rgba(255,204,0,.15)', color: '#FFD700' },
            { label: 'Orange Money', emoji: '📱', bg: 'rgba(255,102,0,.15)', color: '#FF8C00' },
            { label: 'Wave CI', emoji: '💙', bg: 'rgba(0,153,255,.15)', color: '#00BFFF' },
            { label: 'WhatsApp Commerce', emoji: '💬', bg: 'rgba(37,211,102,.15)', color: '#25D366' },
          ].map(p => (
            <span key={p.label} style={{ background: p.bg, border: `1px solid ${p.color}33`, color: p.color, padding: '6px 16px', borderRadius: 'var(--radius-full)', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
              <span>{p.emoji}</span> {p.label}
            </span>
          ))}
        </div>
      </section>

      {/* ── Catégories ── */}
      <section style={{ padding: 'var(--space-3xl) var(--space-xl)', maxWidth: 1320, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-2xl)' }}>
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.2em', color: 'var(--prune)', display: 'block', marginBottom: 12 }}>Nos collections</span>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: 300, color: 'var(--prune-dark)' }}>
            Toute la mode africaine<br /><em style={{ color: 'var(--prune-light)' }}>en un seul endroit</em>
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 'var(--space-md)' }}>
          {CATEGORIES.map(c => (
            <Link key={c.id} to={`/boutique?categorie=${c.id}`}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '28px 16px', background: 'white', border: '1.5px solid var(--creme-dark)', borderRadius: 'var(--radius-xl)', textDecoration: 'none', transition: 'all .25s var(--ease)', cursor: 'pointer' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--prune-light)'; e.currentTarget.style.boxShadow = 'var(--shadow-prune)'; e.currentTarget.style.transform = 'translateY(-4px)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--creme-dark)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              <span style={{ fontSize: 36, lineHeight: 1 }}>{c.icon}</span>
              <div style={{ textAlign: 'center' }}>
                <p style={{ fontFamily: 'var(--font-display)', fontSize: 17, fontWeight: 400, color: 'var(--prune-dark)', marginBottom: 4 }}>{c.label}</p>
                <p style={{ fontSize: 11, color: 'var(--gris-mid)', fontFamily: 'var(--font-mono)' }}>{c.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* ── Produits vedettes ── */}
      {featuredProducts.length > 0 && (
        <section style={{ padding: '0 var(--space-xl) var(--space-3xl)', maxWidth: 1320, margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 'var(--space-xl)' }}>
            <div>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.2em', color: 'var(--prune)', display: 'block', marginBottom: 8 }}>Nouveautés</span>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 36, fontWeight: 300, color: 'var(--prune-dark)' }}>Dernières arrivées</h2>
            </div>
            <Link to="/boutique" style={{ color: 'var(--prune)', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Voir tout →</Link>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 'var(--space-lg)' }}>
            {featuredProducts.map(p => (
              <div key={p.id} onClick={() => navigate(`/produit/${p.id}`)}
                style={{ cursor: 'pointer', background: 'white', borderRadius: 'var(--radius-lg)', overflow: 'hidden', border: '1px solid var(--creme-dark)', transition: 'all .3s var(--ease)' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = 'var(--shadow-md)'; e.currentTarget.style.transform = 'translateY(-4px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <div style={{ aspectRatio: '3/4', background: 'linear-gradient(135deg, var(--creme) 0%, var(--creme-dark) 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 48 }}>
                  {p.images?.[0] ? <img src={p.images[0]} alt={p.nom} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : '🌺'}
                </div>
                <div style={{ padding: 'var(--space-md)' }}>
                  <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10, textTransform: 'uppercase', letterSpacing: '.1em', color: 'var(--prune)', display: 'block', marginBottom: 4 }}>{p.categorie}</span>
                  <p style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 400, color: 'var(--prune-dark)', marginBottom: 8 }}>{p.nom}</p>
                  <p style={{ fontFamily: 'var(--font-mono)', fontSize: 15, fontWeight: 700, color: 'var(--prune)' }}>{(p.prix_promo || p.prix).toLocaleString('fr-CI')} FCFA</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* ── Bannière WhatsApp ── */}
      <section style={{ background: 'linear-gradient(135deg, var(--prune) 0%, var(--prune-light) 100%)', padding: 'var(--space-2xl) var(--space-xl)', textAlign: 'center' }}>
        <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 300, fontSize: 32, color: 'var(--creme)', marginBottom: 12 }}>
          Commander via WhatsApp
        </h2>
        <p style={{ color: 'rgba(253,246,236,.7)', fontSize: 15, marginBottom: 28 }}>Passez commande directement sur WhatsApp — rapide, simple et sécurisé</p>
        <a href="https://wa.me/225XXXXXXXX" target="_blank" rel="noreferrer"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 10, padding: '14px 32px', background: '#25D366', color: 'white', borderRadius: 'var(--radius-md)', fontSize: 15, fontWeight: 700, textDecoration: 'none', boxShadow: '0 4px 20px rgba(37,211,102,.4)' }}>
          <span style={{ fontSize: 20 }}>💬</span> Commander sur WhatsApp
        </a>
      </section>

      {/* ── Footer ── */}
      <footer style={{ background: 'var(--prune-dark)', padding: 'var(--space-2xl) var(--space-xl)', textAlign: 'center' }}>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: 24, color: 'var(--or)', letterSpacing: '.15em', marginBottom: 8 }}>FABI LUXE</div>
        <p style={{ color: 'rgba(253,246,236,.4)', fontSize: 12, fontFamily: 'var(--font-mono)', letterSpacing: '.08em' }}>FASHION STORE · CÔTE D'IVOIRE · © 2025</p>
      </footer>
    </div>
  );
}
